export default {
  // ============================================
  // Record getters (API-backed page documents)
  // ============================================

  // All records as array
  allRecords: (state) => Object.values(state.recordsById),

  // Get records filtered by location
  recordsByLocation: (state) => (location) =>
    Object.values(state.recordsById).filter(
      (record) => record.location === location
    ),

  // Get record by ID
  recordById: (state) => (recordId) => state.recordsById[recordId],

  // Get record for a loaded page
  recordForPage: (state) => (pageId) => {
    const page = state.pagesById[pageId];
    if (!page || !page.recordId) return null;
    return state.recordsById[page.recordId];
  },

  // ============================================
  // Page getters (in-memory page content)
  // ============================================

  activePage: (state) => state.pagesById[state.activePageId],

  // Get page by pageId
  pageById: (state) => (pageId) => state.pagesById[pageId],

  nodeById: (state) => (nodeId) => state.nodesById[nodeId],

  childrenOf: (state) => (parentId, pageId) => {
    const key = parentId || `root_${pageId}`;
    return (state.childrenByParent[key] || [])
      .map((id) => state.nodesById[id])
      .filter(Boolean);
  },

  rootNodes: (state, getters) => (pageId) => {
    return getters.childrenOf(null, pageId);
  },

  componentFor: (state) => (nodeType) => {
    return state.registeredComponents[nodeType] || null;
  },

  /**
   * Serialize page back to JSON for persistence.
   * Returns the page content object (goes inside record.page).
   */
  serializePage: (state) => (pageId) => {
    const page = state.pagesById[pageId];
    if (!page) return null;

    const nodes = {};
    const childrenByParent = {};

    Object.values(state.nodesById)
      .filter((n) => n.pageId === pageId)
      .forEach((node) => {
        // Consolidate props for storage efficiency
        let props = node.props;

        // For markdownStream nodes, join chunks into a single string
        // This prevents storing thousands of single-character entries
        if (node.nodeType === 'markdownStream' && Array.isArray(props.chunks)) {
          props = {
            ...props,
            chunks: props.chunks.length > 0 ? [props.chunks.join('')] : [],
          };
        }

        nodes[node.id] = {
          id: node.id,
          parentId: node.parentId,
          nodeType: node.nodeType,
          props,
          afterId: node.afterId,
          draggable: node.draggable,
          droppable: node.droppable,
        };
      });

    Object.entries(state.childrenByParent)
      .filter(([key]) => key.includes(pageId) || nodes[key])
      .forEach(([key, children]) => {
        childrenByParent[key] = [...children];
      });

    return {
      id: pageId, // Backend expects page.id
      meta: page.meta,
      nodes,
      childrenByParent,
    };
  },
};
